export default function ImageBanner({ image, text }) {
    return (
        <div className="image-banner">
            <img src={image} />
            <div className="image-banner-text">
                {text}
            </div>
        </div>
    );
}